/**
 * Dimensões do canvas Fabric.js no editor.
 * Usadas na inicialização do canvas, aplicação de zoom, preview e `getPreviewDataUrl`.
 */
export const CANVAS_DIMENSIONS = {
  desktop: { width: 632, height: 512 },
  mobile: { width: 240, height: 400 },
} as const;

/**
 * Dimensões de referência de dispositivo real.
 * Usadas no JSON exportado e em labels de exibição (EditorTopBar).
 * A largura/altura do mobile reflete um smartphone comum — não o canvas do editor.
 */
export const TARGET_DIMENSIONS = {
  desktop: { width: 632, height: 512 },
  mobile: { width: 390, height: 844 },
} as const;
